import { isFeatureEnabled } from '@luna/gatekeeper';

export const isSortingEnabledForContext = (isGlobalSearch: boolean): boolean =>
    isGlobalSearch
        ? isFeatureEnabled((f) => f.trx.sortGlobalSearch)
        : isFeatureEnabled((f) => f.trx.sortAccHis);
